import SocketAPI from "@/apis/socket/SocketAPI";
import commonFn from "@/commons/commonFunction";

class Socket {
  constructor() {}

  async init() {
    // lấy token
    let getToken = commonFn.getLocalStorage(window._socketKey);

    if (!getToken) {
      getToken = await this.getTokenConnect();

      if (!getToken?.token) {
        return;
      }
      commonFn.setLocalStorage(window._socketKey, JSON.stringify(getToken));
    } else {
      getToken = JSON.parse(getToken);
    }

    MWSClient.init({
      socketURL: getToken.brokerUrl,
      token: getToken.token,
      onConnectError: (e) => {
        console.log(`Kết nối socket thất bại: ${e}`);
      },
      onTokenInvalid: async () => {
        // gọi Api lấy lại token
        let token = await this.getTokenConnect();
        if (token?.token) {
          MWSClient.reconnect(token.token);
          commonFn.setLocalStorage(window._socketKey, JSON.stringify(token));
        }
      },
      onDisconnect: () => {
        console.log("Kết nối socket đã đóng");
      },
    });
  }

  on(eventName, callback) {
    MWSClient.on(eventName, callback);
  }

  // hủy kết nối socket
  disconnect() {
    // MWSClient.disconnect();
  }

  async getTokenConnect() {
    const getTokenRes = await SocketAPI.getToken();
    if (getTokenRes.error || !getTokenRes?.success) {
      console.log("Lỗi lấy token MWS");
      return null;
    }
    return getTokenRes;
  }

  removeSocketToken() {
    commonFn.removeLocalStorage(window._socketKey);
  }
}

export default new Socket();
